import React from 'react';
import CustomerSupplierDTO from 'features/customer/dtos/CustomerSupplierDTO';
import CommodityIcon from 'features/shared/components/icons/CommodityIcon';
import { useTranslation } from 'react-i18next';
import CommodityIconList from 'features/shared/components/icons/CommodityIconList';

type Props = {
  supplier: CustomerSupplierDTO;
}

const SupplierInfoCard = ({ supplier }: Props) => {
  // translations
  const { t } = useTranslation(["customer\\enums\\contactType"]);

  // sub-renders
  const renderContacts  = () => { 
    if (supplier.contacts) {
      return supplier.contacts.map((contact, index) =>
        <div className="small" key={index}>
          <span className="text-muted mr-2">{t(contact.contactType!)}:</span>
          <span>{contact.value}</span>
        </div>
      );
    }
  }

  // render
  return (
    <div className="row no-gutters">
      <div className="col-auto pr-3">
        <CommodityIconList 
          commodityDetails={supplier.commodityDetail!} 
          includeColor
          iconSize="lg"
          dividerClass="mx-2"
        />
      </div>
      <div className="col">
        <h5>{supplier.supplierName}</h5>  
        {renderContacts()}
      </div>  
    </div>
  )
}

export default SupplierInfoCard;